export type PushPermission = 'granted' | 'denied' | 'prompt' | 'unsupported';

/**
 * What the API stores to reach this device (POST /v1/push/register, PushRegister). The native
 * apps send their platform with the token: Android an FCM registration token (at most 512
 * characters), iOS its APNs device token (hex).
 */
export type PushSubscriptionInfo =
  | { kind: 'webpush'; endpoint: string; keys: { p256dh: string; auth: string } }
  | { kind: 'fcm'; token: string; platform?: 'android' | 'ios' }
  | { kind: 'apns'; token: string; platform?: 'ios' };

export interface PushProvider {
  readonly kind: 'web' | 'native' | 'dev' | 'none';
  permissionState(): Promise<PushPermission>;
  /** Ask only after the player opted in from a pre-prompt (never on first launch). */
  requestPermission(): Promise<PushPermission>;
  subscribe(): Promise<PushSubscriptionInfo | null>;
  unsubscribe(): Promise<void>;
}

export class NoPushProvider implements PushProvider {
  readonly kind = 'none';
  async permissionState(): Promise<PushPermission> {
    return 'unsupported';
  }
  async requestPermission(): Promise<PushPermission> {
    return 'unsupported';
  }
  async subscribe(): Promise<PushSubscriptionInfo | null> {
    return null;
  }
  async unsubscribe(): Promise<void> {}
}
